import React, { useState } from 'react';
import AppsIcon from '@mui/icons-material/Apps';
import { IconButton, Menu, MenuItem } from '@mui/material';
import ICS2Logo from '../../assets/images/ics2-logo.png';
import ENSLogo from '../../assets/images/ens-logo.png';
import logo360Pay from '../../assets/images/360pay-grey-logo.png';

const trimmedENSUrl = process.env.REACT_APP_ENS_FRONTEND_URL?.endsWith('/')
  ? process.env.REACT_APP_ENS_FRONTEND_URL.slice(0, -1)
  : process.env.REACT_APP_ENS_FRONTEND_URL;

const BUTTONS = [
  {
    logo: ICS2Logo,
    alt: 'CABIE ICS2 Logo',
    style: {
      height: '50px',
      width: 'auto',
      marginTop: 17,
      marginBottom: 17,
    },
    onClickURL: '/dashboard',
  },
  {
    logo: ENSLogo,
    alt: 'CABIE ENS Logo',
    style: {
      height: '52px',
      width: 'auto',
      marginTop: 15,
      marginBottom: 15,
    },
    onClickURL: trimmedENSUrl ? `${trimmedENSUrl}?ssoredirect=1` : 'http://localhost:81?ssoredirect=1',
  },
];

const MoreAppsButton = () => {
  const [openMenu, setOpenMenu] = useState(null);

  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const handleMenuItemClick = (url) => {
    //open the URL in a new tab
    window.open(url, '_blank');
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-controls={openMenu ? 'apps-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
      >
        <AppsIcon sx={{ color: '#00395d', height: '40px', width: '40px' }} />
      </IconButton>
      <Menu
        id="apps-menu"
        anchorEl={openMenu}
        open={!!openMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'apps-button',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            borderBottom: '1px solid #eee',
          }}
        >
          <MenuItem key="360Pay" onClick={() => handleMenuItemClick('https://ferryrail.360pays.com/')}>
            <img
              src={logo360Pay}
              alt="CABIE 360Pay Logo"
              style={{
                height: '35px',
                width: 'auto',
                marginTop: 22,
                marginBottom: 22,
                marginLeft: 10,
              }}
            />
          </MenuItem>
        </div>
        {BUTTONS.map((button, index) => (
          <MenuItem key={index} onClick={() => handleMenuItemClick(button.onClickURL)}>
            <img src={button.logo} alt={button.alt} style={button.style} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoreAppsButton;
